import {Button, Form, Input, Modal, Select, Tabs} from 'antd';
import {Content} from 'antd/lib/layout/layout';
import {PlusOutlined} from '@ant-design/icons';
import {useEffect, useState} from 'react';
import {useAppDispatch, useAppSelector} from '../../../../common/hooks';
import {addGroup, groupList} from './stationGroupsSlice';
import type {ADD_STATION_GROUP} from './stationGroups.type';
import {stationsList} from '../stations/stationsSlice';
import Groups from './Groups';
import {debounce} from 'lodash';
import {debounceDelay} from '../../../../common/constants';

const StationGroups = () => {
  const [addGroupModelOpen, setAddGroupModelOpen] = useState(false);
  const stationGroups = useAppSelector((state) => state.stationGroups.stationGroups);
  const userPermission = useAppSelector((state) => state.config.config.permissions);
  const dispatch = useAppDispatch();
  const [addGroupForm] = Form.useForm();
  const [key, setKey] = useState('0');
  const stations = useAppSelector((state) => state.stations.stations.pageData);

  const {Option} = Select;

  const handleAddGroup = (values: ADD_STATION_GROUP) => {
    dispatch(addGroup(values))
      .unwrap()
      .then(() => {
        setAddGroupModelOpen(false);
        addGroupForm.resetFields();
        dispatch(groupList());
      });
  };

  const handleStationBouncing = debounce((e) => {
    dispatch(stationsList({search: e, is_active: true}));
  }, debounceDelay);

  useEffect(() => {
    dispatch(groupList())
      .unwrap()
      .then(() => {
        setKey(stationGroups[0]?.name);
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <>
      <Content
        style={{background: '#ffffff', paddingTop: '10px', height: '100%'}}
        className='vertical-tabs'
      >
        <Tabs
          activeKey={key}
          tabPosition={'left'}
          destroyInactiveTabPane
          tabBarExtraContent={
            userPermission.add_stationgroup && (
              <Button
                icon={<PlusOutlined />}
                type='primary'
                style={{marginRight: '8px'}}
                onClick={() => {
                  dispatch(stationsList({is_active: true}));
                  setAddGroupModelOpen(true);
                }}
              >
                Add Group
              </Button>
            )
          }
          onChange={(x) => {
            setKey(x);
          }}
          style={{height: '100%', width: '100%'}}
          items={stationGroups.map((x) => {
            return {
              label: `${x.name}`,
              key: `${x.name}`,
              children: <Groups station={x} />,
            };
          })}
        />
      </Content>

      <Modal
        title='New Station Group'
        open={addGroupModelOpen}
        onCancel={() => {
          setAddGroupModelOpen(false);
        }}
        okText={'Add'}
        maskClosable={false}
        style={{height: '700px', width: '800px'}}
        onOk={() => {
          addGroupForm
            .validateFields()
            .then((values) => {
              handleAddGroup(values);
            })
            .catch((info) => {
              console.error('Validate Failed:', info);
            });
        }}
      >
        <Form
          form={addGroupForm}
          name='Add Station'
          labelCol={{span: 5}}
          wrapperCol={{span: 19}}
          layout='horizontal'
        >
          <Form.Item
            label='Name'
            name='name'
            rules={[
              {required: true, message: 'Please enter a name'},
              {min: 4, message: 'Atleast 4 characters are required'},
            ]}
          >
            <Input autoComplete='off' placeholder='Group Name' />
          </Form.Item>
          <Form.Item
            label='Stations'
            name='station_ids'
            rules={[{required: true, message: 'At least one station is required'}]}
          >
            <Select
              showSearch
              mode='multiple'
              placeholder='Search Station'
              defaultActiveFirstOption={false}
              showArrow={false}
              filterOption={false}
              onSearch={(e) => {
                if (e.length > 3) handleStationBouncing(e);
              }}
              notFoundContent={null}
              //loading={}
            >
              {stations.map((x) => (
                <Option key={x.id} value={x.id}>
                  {x.name}
                </Option>
              ))}
            </Select>
          </Form.Item>
        </Form>
      </Modal>
    </>
  );
};

export default StationGroups;
